import React from "react";
import Button from "./Button";
import useUser from "../src/useUser";

const OnboardingHeader: React.FC<{}> = ({}) => {
  const { logout } = useUser();
  return (
    <div className="flex justify-between items-start pb-10">
      <div className="flex items-center space-x-2">
        <img
          alt="Oso Logo"
          src="/logo-bear-black.png"
          className="w-[40px] h-[20px] relative b-0"
        />
        <div className="font-space">
          <span>Oso</span> <span className="font-light">Cloud</span>
        </div>
      </div>
      <div className="flex justify-end gap-2 items-center">
        <Button xsmall theme="primary" href="https://www.osohq.com/meet-oso">
          Meet an Engineer
        </Button>
        <Button xsmall theme="default" href="https://www.osohq.com/docs">
          Docs
        </Button>
        <Button xsmall theme="default" onClick={logout}>
          Log out
        </Button>
      </div>
    </div>
  );
};

export default OnboardingHeader;
